export default {
    locale: 'ru'
}
